import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { BusinessesLoadingDialog } from "./businesses-loading-dialog/BusinessesLoadingDialog";
import { BusinessesCard } from "./BusinessesCard";
import { BusinessesUIProvider } from "./BusinessesUIContext";

import { BusinessDeleteDialog } from "./business-delete-dialog/BusinessDeleteDialog";
import { BusinessesDeleteDialog } from "./businesses-delete-dialog/BusinessesDeleteDialog";
import { BusinessesFetchDialog } from "./businesses-fetch-dialog/BusinessesFetchDialog";
import { BusinessesUpdateStatusDialog } from "./businesses-update-status-dialog/BusinessesUpdateStatusDialog";

function BusinessesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesDeleteDialog show={location.pathname === "/business/draft/deleteBusinesses"} onHide={() => navigate("/business/draft")} />;
}
function BusinessDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <BusinessDeleteDialog show id={id} onHide={() => navigate("/business/draft")} />;
}
function BusinessesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesFetchDialog show={location.pathname === "/business/draft/fetch"} onHide={() => navigate("/business/draft")} />;
}
function BusinessesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesUpdateStatusDialog show={location.pathname === "/business/draft/updateStatus"} onHide={() => navigate("/business/draft")} />;
}

export function BusinessesPageDraft() {
  const navigate = useNavigate();
  const businessesUIEvents = {
    newBusinessButtonClick: () => {
      navigate("/business/new");
    },
    openEditBusinessPage: (id) => {
      navigate(`/business/${id}/edit`);
    },
    openDeleteBusinessDialog: (id) => {
      navigate(`/business/draft/${id}/delete`);
    },
    openDeleteBusinessesDialog: () => {
      navigate(`/business/draft/deleteBusinesses`);
    },
    openFetchBusinessesDialog: () => {
      navigate(`/business/draft/fetch`);
    },
    openUpdateBusinessesStatusDialog: () => {
      navigate("/business/draft/updateStatus");
    },
  };

  return (
    <BusinessesUIProvider businessesUIEvents={businessesUIEvents}>
      <BusinessesLoadingDialog />
      <Routes>
        <Route path="deleteBusinesses" element={<BusinessesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<BusinessDeleteDialogRoute />} />
        <Route path="fetch" element={<BusinessesFetchDialogRoute />} />
        <Route path="updateStatus" element={<BusinessesUpdateStatusDialogRoute />} />
      </Routes>
      <BusinessesCard />
    </BusinessesUIProvider>
  );
}
